import styled from '@emotion/styled';
import { useBrandDetails } from 'dw-au-react-components';
import React from 'react';
import {
	CatalogueIcon,
	HomeIcon,
	PrintIcon,
	ProfileIcon,
	WineGlassIcon,
} from '../../svg';
import CartHeader from '../../Components/ShoppingCart/CartHeader';

const StlyedConfirmationPageMenu = styled.div`
	background-color: #fff0f1;
`;

function Confirmation({
	step,
	setStep,
	isMemberCheckout,
	orderConfirmationData,
	isLoggedIn,
	latestCatalogue,
	title,
}) {
	let latestCatalogueLink =
		'/jsp/offer/common/offer.jsp?name=6182-aussie-reds&promoCode=6184001';
	if (latestCatalogue) {
		latestCatalogueLink = latestCatalogue;
	}

	const { phoneRecr, emailAddress, country, tag } = useBrandDetails();

	const ConfirmationPageMenu = ({ icon, text }) => {
		return (
			<StlyedConfirmationPageMenu>
				<div className='text_big text-red font-weight-500 p-20 d-flex mb-40 text_big align-items-center'>
					{icon}
					{text}
				</div>
			</StlyedConfirmationPageMenu>
		);
	};

	let accountLink = '/jsp/account/common/account_details.jsp',
		wineCellarLink = '/jsp/account/common/account_summary.jsp',
		winePreferenceLink = '/jsp/account/common/account_wine_preference.jsp';
	if (tag === 'wpe' || tag === 'law') {
		accountLink = '/account';
		wineCellarLink = '/account/wine-cellar';
		winePreferenceLink = '/account/preferences';
	}

	return (
		<>
			{orderConfirmationData && (
				<div className='confirmation__page'>
					{!isMemberCheckout && (
						<CartHeader title='Checkout' step={step} setStep={setStep} />
					)}

					<h5 className='mb-40 mt-40 text-center'>
						{title ? title : 'Thanks for your order.'}
					</h5>
					<div className='text_big text-dark-medium mb-40'>
						An email confirmation of your order (
						{orderConfirmationData?.order?.id}) will be sent to you shortly. If
						you have any questions regarding your order, simply contact our
						customer service department at{' '}
						<a className='text-red' href={`tel:${phoneRecr}`}>
							{phoneRecr}
						</a>{' '}
						or by email at{' '}
						<a className='text-red' href={`mailto:${emailAddress}`}>
							{emailAddress}
						</a>
						.
						{/* <br /> <br />
						Please allow 10 - 14 business days for delivery (delivery times vary
						by state). Once again, thank you for your order. */}
					</div>
					<a
						href={`/jsp/checkout/${country.toLowerCase()}/${tag}/accountorderprint.jsp`}
						rel='noreferrer'
						target='_blank'
						className='text-red'
					>
						<ConfirmationPageMenu
							icon={<PrintIcon className='mr-12' />}
							text='Print Order Summary'
						/>
					</a>
					{isLoggedIn && (
						<>
							<a
								href={winePreferenceLink}
								target='_blank'
								rel='noreferrer'
								className='text-red'
							>
								<ConfirmationPageMenu
									icon={<WineGlassIcon className='mr-12' />}
									text='Take our Wine Preferences quiz'
								/>
							</a>
							<a
								href={latestCatalogueLink}
								rel='noreferrer'
								target='_blank'
								className='text-red'
							>
								<ConfirmationPageMenu
									icon={<CatalogueIcon className='mr-12' />}
									text='Shop Latest Catalogue'
								/>
							</a>
							<a
								href={accountLink}
								target='_blank'
								rel='noreferrer'
								className='text-red'
							>
								<ConfirmationPageMenu
									icon={<ProfileIcon className='mr-12' />}
									text='Go to My Account'
								/>
							</a>
							<a
								href={wineCellarLink}
								target='_blank'
								rel='noreferrer'
								className='text-red'
							>
								<ConfirmationPageMenu
									icon={<HomeIcon className='mr-12' />}
									text='Go to My Wine Cellar'
								/>
							</a>
						</>
					)}
				</div>
			)}
		</>
	);
}

export default Confirmation;
